import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnalyticsTrendWidgetComponent } from '@enginuity/analytics/organisms/analytics-trend-widget/analytics-trend-widget.component';
import { HighChartContainerComponent } from '@enginuity/analytics/organisms/high-chart-container/high-chart-container.component';
import { GlobalLoaderWrapperComponent } from '@enginuity/analytics/organisms/global-loader-wrapper/global-loader-wrapper.component';
import { Subject } from 'rxjs';
import { DashboardPaymentsStore } from './dashboard-payments.store';
import { DashboardStore } from '../dashboard/dashboard.store';

@Component({
  selector: 'app-dashboard-payments',
  standalone: true,
  imports: [
    CommonModule,
    AnalyticsTrendWidgetComponent,
    HighChartContainerComponent,
    GlobalLoaderWrapperComponent,
  ],
  templateUrl: './dashboard-payments.component.html',
  styleUrl: './dashboard-payments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DashboardPaymentsStore],
})
export class DashboardPaymentsComponent {
  protected rangeContext = this.dashboardStore.getRangeContextSignal();

  protected paymentAnalyticsResource = this.dashboardPaymentsStore.createPaymentAnalyticsResource(
    this.rangeContext
  );

  protected paymentMethodDistributionResource =
    this.dashboardPaymentsStore.createPaymentMethodDistributionResource(this.rangeContext);

  private destroy$ = new Subject<void>();

  constructor(
    private readonly dashboardStore: DashboardStore,
    private readonly dashboardPaymentsStore: DashboardPaymentsStore
  ) {}
}
